module.exports = __webpack_public_path__ + "static/img/alumni-spotlight.c1e484e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/alumni-spotlight.jpg
// module id = IZT2
// module chunks = 0